import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

export interface SearchableOption {
  value: string | number;
  label: string;
}

interface SearchableSelectProps {
  id: string;
  label: string;
  options: SearchableOption[];
  // The selected option's value as a string; '' means nothing selected.
  value: string;
  onChange: (value: string) => void;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  noOptionsText?: string;
}

// A select you can type into, like the other Timeports filters, for lists of
// people and clients that are too long to scroll.
const SearchableSelect = ({
  id,
  label,
  options,
  value,
  onChange,
  helperText,
  required,
  disabled,
  size = 'small',
  fullWidth,
  noOptionsText,
}: SearchableSelectProps) => (
  <Autocomplete
    id={id}
    options={options}
    value={options.find((option) => String(option.value) === value) || null}
    getOptionLabel={(option) => option.label}
    getOptionSelected={(option, selected) => option.value === selected.value}
    onChange={(_event, option) => onChange(option ? String(option.value) : '')}
    disabled={disabled}
    fullWidth={fullWidth}
    size={size}
    noOptionsText={noOptionsText}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        label={label}
        required={required}
        helperText={helperText}
      />
    )}
  />
);

export default SearchableSelect;
